function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-location",
  x1: 0.001,
  y1: 0.5,
  x2: 0.999,
  y2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#dee1ec"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#95A1B2"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_34935",
  "data-name": "Group 34935",
  transform: "translate(-414 -592)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  width: 35,
  height: 35,
  transform: "translate(414 592)",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  id: "location_grey",
  transform: "translate(403.428 582.047)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4987",
  transform: "translate(19699 22041.854)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_8842",
  d: "M-19671-22031.9a11.043,11.043,0,0,0-10.928,11.154c-.064,10.645,10.928,23.846,10.928,23.846s10.992-13.2,10.928-23.846A11.087,11.087,0,0,0-19671-22031.9Z",
  fill: "url(#linear-gradient-location)"
})), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_6606",
  "data-name": "Ellipse 6606",
  cx: 6.5,
  cy: 6.5,
  r: 6.5,
  transform: "translate(21.5 15)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_6607",
  "data-name": "Ellipse 6607",
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  transform: "translate(25.5 19)",
  fill: "#95A1B2"
})));

var SvgLocationGrey = function SvgLocationGrey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocationGrey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/location-grey.f9f09a2b.svg";
export { ForwardRef as ReactComponent };